import Flex from "@/components-library/layout/flex";
import classes from "./header.module.scss";
import Label from "@/components-library/widgets/label";
function Header() {
  return (
    <Flex align="center" className={classes.container}>
      <Label size="lg" className={classes.label}>
        +39 353 44 33 037
      </Label>
      <Label size="lg" className={classes.label}>
        info@prossimiti.it
      </Label>
    </Flex>
  );
}

export default Header;
